import React from "react";
import { useTranslation } from "react-i18next";

const DefaultFooter = () => {
  const { t } = useTranslation();

  const footerLinks = [
    {
      id: 1,
      title: t("footerServicesTitle"),
      menuList: [
        { name: t("footerVisaServices"), path: "/search-visa" },
        { name: t("footerTourPackages"), path: "/trips" },
        { name: t("footerCarRentals"), path: "/car-rent" },
        { name: t("footerFlightBooking"), path: "/flights" },
      ],
    },
    {
      id: 2,
      title: t("footerCompanyTitle"),
      menuList: [
        { name: t("footerAboutUs"), path: "/about" },
        { name: t("footerBlog"), path: "/blogs" },
        { name: t("footerFaq"), path: "/faq" },
      ],
    },
    {
      id: 3,
      title: t("footerSupportTitle"),
      menuList: [
        { name: t("footerContactUs"), path: "/contact" },
        { name: t("footerPrivacyPolicy"), path: "/privacy-policy" },
        { name: t("footerTerms"), path: "/terms-and-conditions" },
        { name: t("footerPaymentInfo"), path: "/payment-guidelines" },
        { name: t("footerLegalDisclaimer"), path: "/legal-disclaimer" },
      ],
    },
  ];

  const contactContent = [
    {
      id: 1,
      title: t("callUs"),
      action: "tel:+96893579571",
      text: "+968 93579571",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      ),
    },
    {
      id: 2,
      title: t("emailUs"),
      action: "mailto:info@silverjarz.com",
      text: "info@silverjarz.com",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path d="m22 6-10 7L2 6" />
        </svg>
      ),
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      className="footer-section"
      style={{
        color: "#ffffff",
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(180deg, #294b5a 0%, #223f4c 100%)",
        borderRadius: "28px 28px 0 0",
      }}
    >
      <style>{`
        .footer-section::before {
          content: "";
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 2px;
          background: linear-gradient(90deg, rgba(211,190,118,0) 0%, rgba(211,190,118,0.85) 50%, rgba(211,190,118,0) 100%);
        }
        .footer-section::after {
          content: "";
          position: absolute;
          top: -120px; left: -80px;
          width: 420px; height: 420px;
          background: radial-gradient(circle, rgba(211,190,118,0.12) 0%, rgba(211,190,118,0) 70%);
          pointer-events: none;
        }

        @media (min-width: 992px) {
          .footer-col { position: relative; }
          .footer-col::before {
            content: "";
            position: absolute;
            top: 4px; bottom: 4px; left: -24px;
            width: 1px;
            background: rgba(211,190,118,0.15);
          }
          .footer-col--first::before { display: none; }
        }

        .footer-heading { position: relative; display: inline-block; padding-bottom: 12px; }
        .footer-heading::after {
          content: "";
          position: absolute;
          left: 0; bottom: 0;
          width: 28px; height: 2px;
          background: #d3be76;
          border-radius: 2px;
        }

        .footer-link {
          position: relative;
          display: inline-flex;
          align-items: center;
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          transition: color 0.2s ease, padding-left 0.2s ease;
        }
        .footer-link::before {
          content: "";
          width: 0; height: 1px;
          background: #d3be76;
          margin-right: 0;
          transition: width 0.2s ease, margin-right 0.2s ease;
        }
        .footer-link:hover { color: #d3be76; }
        .footer-link:hover::before { width: 10px; margin-right: 8px; }

        .footer-contact-item { display: flex; align-items: center; gap: 12px; }
        .footer-contact-icon {
          flex-shrink: 0;
          width: 38px; height: 38px;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          background: rgba(211,190,118,0.1);
          border: 1px solid rgba(211,190,118,0.3);
          color: #d3be76;
          transition: background 0.2s ease, transform 0.2s ease, color 0.2s ease;
        }
        .footer-contact-item:hover .footer-contact-icon { background: #d3be76; color: #223f4c; transform: translateY(-2px); }

        .footer-social { display: flex; gap: 10px; }
        .footer-social a {
          width: 36px; height: 36px;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          border: 1px solid rgba(255,255,255,0.2);
          color: #ffffff;
          font-size: 14px;
          text-decoration: none;
          transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
        }
        .footer-social a:hover { background: #d3be76; border-color: #d3be76; color: #223f4c; transform: translateY(-3px); }

        .footer-bottom { background: rgba(0,0,0,0.18); border-top: 1px solid rgba(211,190,118,0.15); }
        .footer-bottom__legal a { color: rgba(255,255,255,0.55); font-size: 13px; text-decoration: none; transition: color 0.2s ease; }
        .footer-bottom__legal a:hover { color: #d3be76; }
        .footer-bottom__legal span.sep { color: rgba(255,255,255,0.25); margin: 0 10px; }

        .back-to-top {
          display: inline-flex; align-items: center; gap: 8px;
          color: rgba(255,255,255,0.6);
          font-size: 13px;
          cursor: pointer;
          border: none;
          background: transparent;
          transition: color 0.2s ease;
        }
        .back-to-top__icon {
          width: 30px; height: 30px;
          border-radius: 50%;
          border: 1px solid rgba(211,190,118,0.4);
          display: flex; align-items: center; justify-content: center;
          color: #d3be76;
          transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
        }
        .back-to-top:hover { color: #d3be76; }
        .back-to-top:hover .back-to-top__icon { background: #d3be76; color: #223f4c; transform: translateY(-2px); }

        @media (max-width: 767px) {
          .footer-bottom__inner { flex-direction: column; gap: 12px; text-align: center; }
        }
        @media (prefers-reduced-motion: reduce) {
          .footer-link, .footer-social a, .back-to-top__icon, .footer-contact-icon { transition: none; }
        }
      `}</style>

      <div className="container">
        <div className="pt-50 pb-30">
          <div className="row y-gap-40 justify-between">

            {/* Brand & Contact */}
            <div className="col-xl-3 col-lg-4 col-sm-6 footer-col footer-col--first">
              <h4 className="text-20 fw-600 mb-15" style={{ color: "#d3be76" }}>
                {t("footerBrandTitle")}
              </h4>
              <p className="text-14 lh-16 text-white-50 mb-25">
                {t("footerBrandDesc")}
              </p>

              <div className="d-flex flex-column y-gap-18 mb-25">
                {contactContent.map((item) => (
                  <div key={item.id} className="footer-contact-item">
                    <span className="footer-contact-icon">{item.icon}</span>
                    <div className="text-14">
                      <div className="text-white-50 text-12">{item.title}</div>
                      <a href={item.action} className="text-15 fw-500 hover-gold" style={{ color: "#ffffff" }}>
                        {item.text}
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              <div className="footer-social">
                <a href="https://web.facebook.com/jarzsilver/?_rdc=1&_rdr#" target="_blank" aria-label="Facebook"><i className="icon-facebook" /></a>
                <a href="#" target="_blank" aria-label="Twitter"><i className="icon-twitter" /></a>
                <a href="https://www.instagram.com/silverjarz/" target="_blank" aria-label="Instagram"><i className="icon-instagram" /></a>
                <a href="https://www.linkedin.com/in/silverjarz-travel-tourism-a76b95338?originalSubdomain=om" target="_blank" aria-label="LinkedIn"><i className="icon-linkedin" /></a>
              </div>
            </div>

            {/* Navigation Columns */}
            {footerLinks.map((item) => (
              <div className="col-xl-2 col-lg-3 col-sm-6 footer-col" key={item.id}>
                <h5 className="text-16 fw-500 mb-20 footer-heading" style={{ color: "#d3be76" }}>
                  {item.title}
                </h5>
                <div className="d-flex y-gap-12 flex-column">
                  {item.menuList.map((menu, i) => (
                    <a href={menu.path} key={i} className="text-14 footer-link">
                      {menu.name}
                    </a>
                  ))}
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom pb-80">
        <div className="container">
          <div className="d-flex items-center justify-between py-20 footer-bottom__inner">
            <p className="text-13 text-white-50 mb-0">
              © {new Date().getFullYear()} {t("footerBrandTitle")}. {t("allRightsReserved")}
            </p>

            <div className="d-flex items-center footer-bottom__legal">
              <a href="/privacy-policy">{t("footerPrivacyPolicy")}</a>
              <span className="sep">•</span>
              <a href="/terms-and-conditions">{t("footerTerms")}</a>
            </div>

            <button className="back-to-top" onClick={scrollToTop}>
              {t("backToTop")}
              <span className="back-to-top__icon">↑</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DefaultFooter;